import { Component, Input, OnInit, inject } from '@angular/core';

import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { ConfigService } from '@fcom/core/services';
import { FinnairCabinClass, FinnairOrder } from '@fcom/dapi/api/models';
import { LanguageService } from '@fcom/ui-translate';
import { loginStatus } from '@fcom/core/selectors';
import { AspectRatioString } from '@fcom/common/interfaces';
import { LoginStatus } from '@fcom/core-api/login';
import { BookingAppState } from '@fcom/common/interfaces/booking';

@Component({
  selector: 'fin-promotion-banners',
  templateUrl: './promotion-banners.component.html',
  styleUrls: ['./promotion-banners.component.scss'],
  standalone: false,
})
export class PromotionBannersComponent implements OnInit {
  private configService = inject(ConfigService);
  private languageService = inject(LanguageService);
  private store$ = inject<Store<BookingAppState>>(Store);

  readonly LoginStatus = LoginStatus;

  @Input()
  orderData$?: Observable<FinnairOrder> = of(null);

  aspectRatio$: Observable<AspectRatioString>;

  loggedIn$: Observable<LoginStatus>;

  chooseUrl$: Observable<string>;
  finnairShopDonateUrl: string;

  cabinClassMap = {
    [FinnairCabinClass.ECONOMY]: 'economy',
    [FinnairCabinClass.ECOPREMIUM]: 'premiumEconomy',
    [FinnairCabinClass.BUSINESS]: 'business',
    [FinnairCabinClass.FIRST]: 'first',
  };

  ngOnInit(): void {
    this.loggedIn$ = this.store$.pipe(loginStatus());

    let lang = this.languageService.langKeyValue?.toLowerCase();

    // Only EN FI SV languages are supported by Chooose.
    if (!['en', 'fi', 'sv'].includes(lang)) {
      lang = 'en';
    }

    this.finnairShopDonateUrl = this.configService.cfg.finnairShopDonateUrl.replace('{lang}', lang);
  }
}
